import { useMainStore } from '~/stores/mainStore';

export default defineNuxtRouteMiddleware(() => {
  const mainStore = useMainStore();

  if (!mainStore.siteSettings.subscriptionsEnabled) {
    return navigateTo('/');
  }
});
